import { GpsLocationDto } from '@area-restrita/api-client/model/gpsLocationDto';
import { useBusTrackingStatus } from '@area-restrita/client/hooks';

import { useCurrentLocation } from '@/hooks/useCurrentLocation';

import BusTrackingCardView from './view';

interface BusTrackingCardProps {
  location: GpsLocationDto | null;
  routeName?: string;
  driverName?: string;
  className?: string;
  details?: React.ReactNode;
}

const BusTrackingCard: React.FC<BusTrackingCardProps> = ({
  location,
  routeName,
  driverName,
  className,
  details,
}) => {
  const { currentLocation, handlerLocation } = useCurrentLocation();
  const { busStatus, distanceToStop, estimatedArrival, isRecent, lastUpdate } =
    useBusTrackingStatus({ location, currentLocation });

  return (
    <BusTrackingCardView
      className={className}
      busStatus={busStatus}
      distanceToStop={distanceToStop}
      estimatedArrival={estimatedArrival}
      isRecent={isRecent}
      lastUpdate={lastUpdate}
      location={location}
      routeName={routeName}
      driverName={driverName}
      details={details}
      hasUserLocation={!!currentLocation}
      onRequestUserLocation={handlerLocation}
    />
  );
};

export default BusTrackingCard;
